import { createReducer, on } from '@ngrx/store';

import { goToProjects, setProject } from '../../core/store';
import {
	fetchMetadataListFail,
	fetchMetadataListSuccess,
	initMetadataList,
	refreshMetadataList,
} from './metadata.actions';
import { MetadataState } from './metadata.state';

export const metadataReducer = createReducer<MetadataState>(
	new MetadataState(),
	on(goToProjects, setProject, (state) => state.clear()),
	on(initMetadataList, refreshMetadataList, (state) => state.setLoading(true)),
	on(fetchMetadataListFail, (state) => state.setLoading(false)),
	on(fetchMetadataListSuccess, (state, action) =>
		state.setLoading(false).setMetadataList(action.metadataList)
	)
);
